import { render, staticRenderFns } from "./TouchCapture.vue?vue&type=template&id=972930a8&"
import script from "./TouchCapture.vue?vue&type=script&lang=js&"
export * from "./TouchCapture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports